(function(){
  'use strict';
  var root=document.querySelector('[data-gp-tour]'); if(!root) return;
  var chapters=Array.prototype.slice.call(root.querySelectorAll('.gp-tour__chapter'));
  var links=Array.prototype.slice.call(root.querySelectorAll('.gp-tour__index-link'));
  /* tabs */
  chapters.forEach(function(ch){
    var tabs=ch.querySelectorAll('.gp-tour__tab'), panels=ch.querySelectorAll('.gp-tour__panel');
    tabs.forEach(function(t){ t.addEventListener('click',function(){
      tabs.forEach(function(x){ var on=x===t; x.classList.toggle('is-active',on); x.setAttribute('aria-selected',on?'true':'false'); });
      panels.forEach(function(p){ var on=p.getAttribute('data-panel')===t.getAttribute('data-tab'); p.hidden=!on; p.classList.toggle('is-active',on); });
    }); });
  });
  /* reveal + current index */
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); var id=e.target.id; links.forEach(function(l){ var cur=l.getAttribute('data-slug')===id; l.classList.toggle('is-current',cur); if(cur && l.scrollIntoView) { try{ l.scrollIntoView({block:'nearest',inline:'center',behavior:'smooth'}); }catch(err){} } }); } }); },{threshold:0.35});
    chapters.forEach(function(c){ io.observe(c); });
  } else { chapters.forEach(function(c){ c.classList.add('is-in'); }); }
  /* filters */
  root.querySelectorAll('.gp-tour__filter').forEach(function(f){ f.addEventListener('click',function(){
    var v=f.getAttribute('data-filter');
    root.querySelectorAll('.gp-tour__filter').forEach(function(x){ x.classList.toggle('is-active',x===f); });
    chapters.forEach(function(c){ c.classList.toggle('is-filtered', v!=='all' && c.getAttribute('data-formula')!==v); });
    links.forEach(function(l){ var ch=document.getElementById(l.getAttribute('data-slug')); l.classList.toggle('is-hidden', !!(ch && ch.classList.contains('is-filtered'))); });
  }); });
  /* deep link: open the chapter and reveal */
  if(location.hash){ var t=document.getElementById(location.hash.slice(1)); if(t){ setTimeout(function(){ t.scrollIntoView({block:'start'}); t.classList.add('is-in'); },200); } }
})();
